module.exports = __webpack_public_path__ + "img/12.a013a4a5.gif";